import { lazy } from 'react'
import RequireMenuPermission from '../components/RequireMenuPermission'
import { DepartmentList } from '../containers/DepartmentList'
import { HomePage } from '../containers/Home'
import MenuCreate from '../containers/MenuCreate'
import MenuEdit from '../containers/MenuEdit'
import { MenuList } from '../containers/MenuList'
import PermissionsCreate from '../containers/PermissionsCreate'
import PermissionList from '../containers/PermissionsList'
import { PositionList } from '../containers/PositionList'
// import ReservationManage from '../containers/ReservationManage'
// import DetailModel from '../containers/VehicleMaster/VehicleModel/'
import { EvMeterLogPage } from '../containers/EvMeterLog'

// Revenue Intelligence is only exposed to callers whose permission data (the same
// listMenu/can_read data managed on the /permissions page) grants read access to this exact
// path. This wrapper is only used by this one route entry below, so it cannot affect any
// other route.
const RevenueIntelligenceContainer = lazy(() => import('../containers/Revenue-intelligence'))
const RevenueIntelligenceGuarded = (): JSX.Element => (
  <RequireMenuPermission path="/analytics/revenue-intelligence">
    <RevenueIntelligenceContainer />
  </RequireMenuPermission>
)

const BkiReportingContainer = lazy(() => import('../containers/BkiReporting'))
const BkiReportingGuarded = (): JSX.Element => (
  <RequireMenuPermission path="/insurance/bki-reporting">
    <BkiReportingContainer />
  </RequireMenuPermission>
)

export type RouteItem = {
  title: string
  path: string
  requireAuth: boolean
  container: any
  // | ((...args: any) => JSX.Element)
  // | typeof React.Component
  // | React.LazyExoticComponent<(...args: any) => JSX.Element>
  // | React.LazyExoticComponent<typeof React.Component>
}

const routes: RouteItem[] = [
  {
    title: 'BKI insurance reporting',
    path: '/insurance/bki-reporting',
    requireAuth: true,
    container: BkiReportingGuarded,
  },
  { title: 'Home', path: '/', requireAuth: true, container: HomePage },
  {
    title: 'Reservation Check in-out checklist',
    path: '/reservation/checklist',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationCheckinoutChecklist')),
  },
  {
    title: 'Vehicle features list',
    path: '/vehicle/key-features',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleFeatures/List')),
  },
  {
    title: 'Car Request Submission',
    path: '/car-request-submission',
    requireAuth: true,
    container: lazy(() => import('../containers/CarRequestSubmission')),
  },
  {
    title: 'Submission List',
    path: '/submission',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleSubmissionList')),
  },
  {
    title: 'Submission Chat',
    path: '/submission/chat/:uuid?',
    requireAuth: true,
    container: lazy(() => import('../containers/SubmissionChat')),
  },
  {
    title: 'Submission Detail',
    path: '/submission/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleSubmissionDetail')),
  },
  // {
  //   title: 'Feature Pin',
  //   path: '/feature-pin',
  //   requireAuth: true,
  //   container: FeaturePin,
  // },
  // { title: 'BestDeal', path: '/deal', requireAuth: true, container: BeastDeal },
  {
    title: 'PushNotification',
    path: '/notification',
    requireAuth: true,
    container: lazy(() => import('../containers/PushNotification')),
  },
  {
    title: 'PushNotification',
    path: '/notification/all',
    requireAuth: true,
    container: lazy(() => import('../containers/PushNotification/pushNotificationSchedule')),
  },

  {
    title: 'PushNotification',
    path: '/notification/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/PushNotification')),
  },
  {
    title: 'EvCharger',
    path: '/charger',
    requireAuth: true,
    container: lazy(() => import('../containers/EvCharger')),
  },
  {
    title: 'EvStation',
    path: '/charger/station',
    requireAuth: true,
    container: lazy(() => import('../containers/EvStation')),
  },
  {
    title: 'EvSubMissionStation',
    path: '/charger/submission/station',
    requireAuth: true,
    container: lazy(() => import('../containers/EvSubmissionStation')),
  },
  {
    title: 'EvSubMissionStation Edit',
    path: '/charger/submission/station/edit/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/EvSubmissionStationEdit')),
  },
  {
    title: 'EvCharger(Pricing)',
    path: '/charger/pricing',
    requireAuth: true,
    container: lazy(() => import('../containers/Pricing')),
  },
  {
    title: 'EvCharger(Vehicle)',
    path: '/charger/Vehicle',
    requireAuth: true,
    container: lazy(() => import('../containers/EvCharger/Vehicle')),
  },
  {
    title: 'Ev Reservation',
    path: '/charger/reservation',
    requireAuth: true,
    container: lazy(() => import('../containers/EvReservation')),
  },
  {
    title: 'Ev Reservation Create',
    path: '/charger/reservation/create',
    requireAuth: true,
    container: lazy(() => import('../containers/EvReservationCreate')),
  },
  {
    title: 'Ev Meter Log',
    path: '/charger/meter-log',
    requireAuth: true,
    container: EvMeterLogPage,
  },
  {
    //*ต้องเช็คอีกทีว่าใส่ในไหน
    title: 'SearchHost',
    path: '/searchhost',
    requireAuth: true,
    container: lazy(() => import('../containers/HostInfo')),
  },
  {
    //*ต้องเช็คอีกทีว่าใส่ในไหน
    title: 'Vehicle Import',
    path: '/vehicle/import',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleImport')),
  },
  {
    title: 'Vehicle Add',
    path: '/vehicle/create',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleAdd')),
  },
  {
    title: 'Vehicle Edit',
    path: '/vehicle/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleEdit')),
  },
  {
    title: 'Vehicle List',
    path: '/vehicle',
    requireAuth: true,
    container: lazy(() => import('../containers/Verified/VehicleManage')),
  },
  // {
  //   title: 'Verified Vehicle',
  //   path: '/verifiedvehicle',
  //   requireAuth: true,
  //   container: VerifiedVehicle,
  // },
  {
    title: 'Verified vehicle info page',
    path: '/verifiedvehicle/insuranceinfo/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/VerifiedVehicle/InfoPage')),
  },
  {
    title: 'Insurance info page',
    path: '/verifiedvehicle/insuranceinfo/createorder/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/VerifiedVehicle/insuranceinfo')),
  },
  // {
  //   title: 'Insurance Management',
  //   path: '/insurance',
  //   requireAuth: true,
  //   container: InsuranceManagement,
  // },
  // {
  //   title: 'Insurance Management',
  //   path: '/insurance',
  //   requireAuth: true,
  //   container: InsuranceManagement,
  // },
  // {
  //   title: 'Contract Management',
  //   path: '/contract',
  //   requireAuth: true,
  //   container: ContractManagement,
  // },
  // {
  //   title: 'Contract Management',
  //   path: '/contract',
  //   requireAuth: true,
  //   container: ContractManagement,
  // },

  {
    title: 'User Manage',
    path: '/usermanage',
    requireAuth: true,
    container: lazy(() => import('../containers/UserManage/Dashboard/UserManage')),
  },
  {
    title: 'Create User',
    path: '/usermanage/create',
    requireAuth: true,
    container: lazy(() => import('../containers/UserManage/CreateUser/CreateUser')),
  },
  {
    title: 'User Manage',
    path: '/usermanage/:user_id',
    requireAuth: true,
    container: lazy(() => import('../containers/UserManage/Dashboard/UserManage')),
  },
  {
    title: 'Edit User',
    path: '/usermanage/edit/:userid',
    requireAuth: true,
    container: lazy(() => import('../containers/UserManage/EditUser/EditUser')),
  },

  {
    title: 'Package Manage',
    path: '/packagemanage',
    requireAuth: true,
    container: lazy(
      () => import('../containers/PackageCampaign/Dashboard/Package/DashboardPackage'),
    ),
  },
  {
    title: 'Create Package',
    path: '/packagemanage/create',
    requireAuth: true,
    container: lazy(() => import('../containers/PackageCampaign/Create/Package/DetailPackage')),
  },
  {
    title: 'Create Package',
    path: '/packagemanage/clone/:package_name',
    requireAuth: true,
    container: lazy(() => import('../containers/PackageCampaign/Clone/ClonePackage')),
  },
  {
    title: 'Edit Package',
    path: '/packagemanage/edit/:package_name',
    requireAuth: true,
    container: lazy(() => import('../containers/PackageCampaign/Edit/EditPackage')),
  },
  {
    title: 'Campaign Manage',
    path: '/campaignmanage',
    requireAuth: true,
    container: lazy(
      () => import('../containers/PackageCampaign/Dashboard/Campaign/DashboardCampaign'),
    ),
  },
  {
    title: 'Create Campaign',
    path: '/campaignmanage/create',
    requireAuth: true,
    container: lazy(() => import('../containers/PackageCampaign/Create/Campaign/DetailCampaign')),
  },
  {
    title: 'Create Campaign',
    path: '/campaignmanage/clone/:campaign_name',
    requireAuth: true,
    container: lazy(() => import('../containers/PackageCampaign/Clone/CloneCampaign')),
  },
  {
    title: 'Create Campaign',
    path: '/campaignmanage/edit/:campaign_name',
    requireAuth: true,
    container: lazy(() => import('../containers/PackageCampaign/Edit/EditCampaign')),
  },

  {
    //*ต้องเช็คอีกทีว่าใส่ในไหน
    title: 'Host Contract',
    path: '/host/contract/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/HostContract')),
  },
  {
    title: 'Banner Management',
    path: '/banner',
    requireAuth: true,
    container: lazy(() => import('../containers/BannerManage')),
  },
  {
    title: 'GroupCode Management',
    path: '/groupcode',
    requireAuth: true,
    container: lazy(() => import('../containers/CampaignCodeManager')),
  },

  {
    //*ต้องเช็คอีกทีว่าใส่ในไหน
    title: 'User Request Management',
    path: '/userrequest',
    requireAuth: true,
    container: lazy(() => import('../containers/Userdeletion')),
  },
  // {
  //   title: 'Price Model',
  //   path: '/pricemodel/:brand',
  //   requireAuth: true,
  //   container: DetailPriceModel,
  // },
  {
    title: 'Price Model',
    path: '/pricemodel',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceModel/Dashboard/DashboardPriceModel')),
  },
  {
    title: 'Price Model',
    path: '/pricemodel/create',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceModel/CreatePriceModel/DetailPriceModel')),
  },
  {
    title: 'Create Price Model',
    path: '/pricemodel/clone/:brand_key/:model_key',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceModel/Clone/ClonePriceModel')),
  },
  {
    title: 'Create Price Model',
    path: '/pricemodel/clone/:brand_key/:model_key/:sub_model',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceModel/Clone/ClonePriceModel')),
  },
  {
    title: 'Edit Price Model',
    path: '/pricemodel/edit/:brand_key/:model_key',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceModel/EditPriceModel/EditPriceModel')),
  },
  {
    title: 'Edit Price Model',
    path: '/pricemodel/edit/:brand_key/:model_key/:sub_model',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceModel/EditPriceModel/EditPriceModel')),
  },

  // {
  //   title: 'Vehicle Master',
  //   path: '/vehiclemaster',
  //   requireAuth: true,
  //   container: Vehicle Master,
  // },
  {
    title: 'Brand Manage',
    path: '/vehiclemaster/brand',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleBrand/index')),
  },
  {
    title: 'Create Brand',
    path: '/vehiclemaster/brand/create',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleBrand/CreateBrand')),
  },
  // {
  //   title: 'Edit Brand',
  //   path: '/vehiclemaster/brand/edit:key',
  //   requireAuth: true,
  //   container: DetailBrand,
  // },
  {
    title: 'Model Manage',
    path: '/vehiclemaster/model',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleModel/index')),
  },
  // },
  {
    title: 'Create Model',
    path: '/vehiclemaster/model/clone',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleModel/CreateModel')),
  },
  {
    title: 'Create Model',
    path: '/vehiclemaster/model/create',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleModel/CreateModel')),
  },
  // {
  //   title: 'Manage Model',
  //   path: '/vehiclemaster/:brand/:model',
  //   requireAuth: true,
  //   container: DetailModel,
  // },
  {
    title: 'Color Manage',
    path: '/vehiclemaster/color',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleColor/index')),
  },
  {
    title: 'Create Color',
    path: '/vehiclemaster/color/create',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleColor/CreateColor')),
  },
  {
    title: 'Type Manage',
    path: '/vehiclemaster/type',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleType/index')),
  },
  {
    title: 'Create Type',
    path: '/vehiclemaster/type/create',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleType/CreateType')),
  },
  {
    title: 'Size International Manage',
    path: '/vehiclemaster/sizeintl',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleSizeIntl/index')),
  },
  {
    title: 'Create Size International',
    path: '/vehiclemaster/sizeintl/create',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleSizeIntl/CreateSizeIntl')),
  },
  {
    title: 'Vehicle Size Manage',
    path: '/vehiclemaster/size',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleSize/index')),
  },
  {
    title: 'Create Vehicle Size',
    path: '/vehiclemaster/size/create',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleMaster/VehicleSize/CreateSize')),
  },
  {
    title: 'User Referral Management',
    path: '/user-referral',
    requireAuth: true,
    container: lazy(() => import('../containers/UserReferral')),
  },
  {
    title: 'Affiliate settings',
    path: '/affiliate/settings',
    requireAuth: true,
    container: lazy(() => import('../containers/Affiliate/Settings')),
  },
  {
    title: 'Affiliates',
    path: '/affiliate/affiliates',
    requireAuth: true,
    container: lazy(() => import('../containers/Affiliate/Affiliates')),
  },
  {
    title: 'Affiliate commissions',
    path: '/affiliate/commissions',
    requireAuth: true,
    container: lazy(() => import('../containers/Affiliate/Commissions')),
  },
  {
    //*ต้องเช็คอีกทีว่าใส่ในไหน
    title: 'TTT Redeem',
    path: '/events/ttt/redeem',
    requireAuth: true,
    container: lazy(() => import('../containers/Events/TTTCouponRedemptionPage')),
    // Paths related to promo code
  },
  {
    title: 'Promotion Code',
    path: '/promocode',
    requireAuth: true,
    container: lazy(() => import('../containers/PromoCode')),
  },
  {
    title: 'Add Promotional Code',
    path: '/promocode/create',
    requireAuth: true,
    container: lazy(() => import('../containers/PromoCodeAdd')),
  },
  {
    title: 'Edit Promotional Code',
    path: '/promocode/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/PromoCodeEdit')),
  },
  {
    title: 'Promotion Management V2',
    path: '/promotion-v2',
    requireAuth: true,
    container: lazy(() => import('../containers/Promotion')),
  },
  {
    title: 'Create Promotion V2',
    path: '/promotion-v2/create',
    requireAuth: true,
    container: lazy(() => import('../containers/Promotion/Create')),
  },
  {
    title: 'Edit Promotion V2',
    path: '/promotion-v2/:id/edit',
    requireAuth: true,
    container: lazy(() => import('../containers/Promotion/Edit')),
  },
  {
    title: 'Price management',
    path: '/price-manage',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceManagement')),
  },
  {
    title: 'Create a price',
    path: '/price-manage/create',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceManagement/PriceManagementAdd')),
  },
  {
    title: 'Create a price',
    path: '/price-manage/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceManagement/PriceManagementEdit')),
  },
  {
    title: 'Create a price rate',
    path: '/price-rate/create/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceRate/PriceRateAdd')),
  },
  {
    title: 'Check price rate',
    path: '/price-rate/all/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceRate')),
  },
  {
    title: 'Edit a price rate',
    path: '/price-rate/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/PriceRate/PriceRateEdit')),
  },
  {
    title: 'Coupon Management',
    path: '/coupon',
    requireAuth: true,
    container: lazy(() => import('../containers/Coupon')),
  },
  {
    title: 'Reservation Check In',
    path: '/reservation/:no/checkin',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationCheckIn')),
  },
  {
    title: 'Reservation Check Out',
    path: '/reservation/:no/checkout',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationCheckOut')),
  },
  {
    title: 'Reservation Management',
    path: '/reservation/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationManage')),
  },
  {
    title: 'Create a reservation',
    path: '/create-reservation',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationManage/ReservationCreate')),
  },
  {
    title: 'Create a reservation',
    path: '/create-reservation-charge',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationManage/ReservationCreateCharge')),
  },
  {
    title: 'Chat Monitor',
    path: '/chat-monitor',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationManage/ChatMonitor')),
  },
  {
    title: 'Chat Monitor detail',
    path: '/chat-monitor/room/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationManage/ChatMonitor/ChatMonitorDetail')),
  },
  {
    title: 'Edit a reservation',
    path: '/reservation/:id/edit',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationManage/ReservationEdit')),
  },
  {
    title: 'Check Coupon TTT2023',
    path: '/transaction/cx',
    requireAuth: true,
    container: lazy(() => import('../containers/CheckCoupon')),
  },
  {
    title: 'Transaction List',
    path: '/transaction/acc',
    requireAuth: true,
    container: lazy(() => import('../containers/TransactionListACC')),
  },
  {
    title: 'Message Template',
    path: '/templating/message',
    requireAuth: true,
    container: lazy(() => import('../containers/Templating/Message')),
  },
  {
    title: 'Logs',
    path: '/logs',
    requireAuth: true,
    container: lazy(() => import('../containers/LogSystem')),
  },
  {
    title: 'Admin Manage',
    path: '/adminManage',
    requireAuth: true,
    container: lazy(() => import('../containers/AdminManageList')),
  },
  {
    title: 'Admin Create',
    path: '/adminManage/create',
    requireAuth: true,
    container: lazy(() => import('../containers/AdminManageCreate')),
  },
  {
    title: 'Check Price',
    path: '/checkPrice',
    requireAuth: true,
    container: lazy(() => import('../containers/checkPriceList')),
  },
  {
    title: 'Groups',
    path: '/groups',
    requireAuth: true,
    container: lazy(() => import('../containers/GroupsManageList')),
  },
  {
    title: 'Group Create',
    path: '/groups/create',
    requireAuth: true,
    container: lazy(() => import('../containers/GroupsManageCreate')),
  },
  {
    title: 'Car check',
    path: '/reservation/:id/checking',
    requireAuth: true,
    container: lazy(() => import('../containers/CarCheckInOut')),
  },
  {
    title: 'Email template',
    path: '/templating/email',
    requireAuth: true,
    container: lazy(() => import('../containers/Templating/Email')),
  },
  {
    title: 'Safe-T',
    path: '/events/safe-t/tickets',
    requireAuth: true,
    container: lazy(() => import('../containers/Safe-T')),
  },
  {
    title: 'Report',
    path: '/report',
    requireAuth: true,
    container: lazy(() => import('../containers/VehicleCalendar')),
  },
  {
    title: 'Invoice',
    path: '/invoice',
    requireAuth: true,
    container: lazy(() => import('../containers/Invoice')),
  },
  {
    title: 'Charge',
    path: '/charge',
    requireAuth: true,
    container: lazy(() => import('../containers/Charge')),
  },
  {
    title: 'Charge',
    path: '/charge/create',
    requireAuth: true,
    container: lazy(() => import('../containers/Charge/newCreateCharge/index')),
  },
  // {
  //   title: 'Charge',
  //   path: '/charge/:id/new',
  //   requireAuth: true,
  //   container: lazy(() => import('../containers/Charge/ChargeCreate')),
  // },
  {
    title: 'New Invoice',
    path: '/invoice/new',
    requireAuth: true,
    container: lazy(() => import('../containers/Invoice/InvoiceCreate')),
  },
  {
    title: 'New Transaction TTT',
    path: '/ttt/new',
    requireAuth: true,
    container: lazy(() => import('../containers/TTTTransactionCreate')),
  },
  {
    title: 'Push Notification for reservation',
    path: '/push-notification-reservation',
    requireAuth: true,
    container: lazy(() => import('../containers/PushNotification/Reservation')),
  },
  {
    title: 'Blacklist Name',
    path: '/blacklist',
    requireAuth: true,
    container: lazy(() => import('../containers/BlacklistManage')),
  },
  {
    title: 'Booking',
    path: '/booking',
    requireAuth: true,
    container: lazy(() => import('../containers/BookingList')),
  },
  {
    title: 'Booking Create',
    path: '/booking/create',
    requireAuth: true,
    container: lazy(() => import('../containers/BookingCreate')),
  },
  {
    title: 'Booking View',
    path: '/booking/:bookingId',
    requireAuth: true,
    container: lazy(() => import('../containers/BookingEdit')),
  },
  {
    title: 'Booking Send Email',
    path: '/booking/:bookingId/sendmail',
    requireAuth: true,
    container: lazy(() => import('../containers/BookingSendEmail')),
  },
  {
    title: 'Address',
    path: '/address',
    requireAuth: true,
    container: lazy(() => import('../containers/AddressList')),
  },
  {
    title: 'Address Create',
    path: '/address/create',
    requireAuth: true,
    container: lazy(() => import('../containers/AddressCreate')),
  },
  {
    title: 'Address View',
    path: '/address/:addressId',
    requireAuth: true,
    container: lazy(() => import('../containers/AddressEdit')),
  },
  {
    title: 'Email Template List',
    path: '/email/template',
    requireAuth: true,
    container: lazy(() => import('../containers/EmailTemplateList')),
  },
  {
    title: 'Email Template Create',
    path: '/email/template/create',
    requireAuth: true,
    container: lazy(() => import('../containers/EmailTemplateCreate')),
  },
  {
    title: 'Email Template Edit',
    path: '/email/template/:templateId',
    requireAuth: true,
    container: lazy(() => import('../containers/EmailTemplateEdit')),
  },
  {
    title: 'Email Sender',
    path: '/email',
    requireAuth: true,
    container: lazy(() => import('../containers/EmailSentLog')),
  },
  {
    title: 'Email Compose',
    path: '/email/compose',
    requireAuth: true,
    container: lazy(() => import('../containers/EmailCompose')),
  },
  {
    title: 'Blacklist Photo',
    path: '/blacklist/photo',
    requireAuth: true,
    container: lazy(() => import('../containers/BlacklistManage/BlacklistPhoto')),
  },
  {
    title: 'Station List',
    path: '/station',
    requireAuth: true,
    container: lazy(() => import('../containers/StationList')),
  },
  {
    title: 'Station Create',
    path: '/station/create',
    requireAuth: true,
    container: lazy(() => import('../containers/StationCreate/StationCreatePage')),
  },
  {
    title: 'Station Edit',
    path: '/station/:stationId',
    requireAuth: true,
    container: lazy(() => import('../containers/StationEdit')),
  },
  {
    title: 'Credit List',
    path: '/credit',
    requireAuth: true,
    container: lazy(() => import('../containers/UserCreditList')),
  },
  {
    title: 'Create Credit',
    path: '/credit/create',
    requireAuth: true,
    container: lazy(() => import('../containers/UserCreditCreate')),
  },
  {
    title: 'User Photo',
    path: '/user-photo',
    requireAuth: true,
    container: lazy(() => import('../containers/UserPhoto')),
  },
  {
    title: 'Department List',
    path: '/department',
    requireAuth: true,
    container: DepartmentList,
  },
  {
    title: 'Position List',
    path: '/department/:id',
    requireAuth: true,
    container: PositionList,
  },
  {
    title: 'Menu Management',
    path: '/menu',
    requireAuth: true,
    container: MenuList,
  },
  {
    title: 'Create Menu',
    path: '/menu/create',
    requireAuth: true,
    container: MenuCreate,
  },
  {
    title: 'Edit Menu',
    path: '/menu/:id/edit',
    requireAuth: true,
    container: MenuEdit,
  },
  {
    title: 'Permission List',
    path: '/permissions',
    requireAuth: true,
    container: PermissionList,
  },
  {
    title: 'Create Permission',
    path: '/permissions/create',
    requireAuth: true,
    container: PermissionsCreate,
  },
  {
    title: 'Department List',
    path: '/department',
    requireAuth: true,
    container: DepartmentList,
  },
  {
    title: 'Position List',
    path: '/department/:id',
    requireAuth: true,
    container: PositionList,
  },
  {
    title: 'Menu Management',
    path: '/menu',
    requireAuth: true,
    container: MenuList,
  },
  {
    title: 'Create Menu',
    path: '/menu/create',
    requireAuth: true,
    container: MenuCreate,
  },
  {
    title: 'Edit Menu',
    path: '/menu/:id/edit',
    requireAuth: true,
    container: MenuEdit,
  },
  {
    title: 'Permission List',
    path: '/permissions',
    requireAuth: true,
    container: PermissionList,
  },
  {
    title: 'Create Permission',
    path: '/permissions/create',
    requireAuth: true,
    container: PermissionsCreate,
  },
  {
    title: 'Standard Price Project Markup',
    path: '/stdPriceProjectMarkup',
    requireAuth: true,
    container: lazy(() => import('../containers/StdPriceProjectMarkup')),
  },
  {
    title: 'Create Standard Price Project Markup',
    path: '/stdPriceProjecMarkup/create',
    requireAuth: true,
    container: lazy(
      () => import('../containers/StdPriceProjectMarkup/CreateStdPriceProjectMarkup'),
    ),
  },
  {
    title: 'Edit Standard Price Project Markup',
    path: '/stdPriceProjectMarkup/edit/:project_id',
    requireAuth: true,
    container: lazy(() => import('../containers/StdPriceProjectMarkup/EditStdPriceProjectMarkup')),
  },
  {
    title: 'Standard Price Channel Markup',
    path: '/stdPriceChannelMarkup',
    requireAuth: true,
    container: lazy(() => import('../containers/StdPriceChannelMarkup')),
  },
  {
    title: 'Create Standard Price Channel Markup',
    path: '/stdPriceChannelMarkup/create',
    requireAuth: true,
    container: lazy(
      () => import('../containers/StdPriceChannelMarkup/CreateStdPriceChannelMarkup'),
    ),
  },
  {
    title: 'Edit Standard Price Channel Markup',
    path: '/stdPriceChannelMarkup/edit/:channel_id',
    requireAuth: true,
    container: lazy(() => import('../containers/StdPriceChannelMarkup/EditStdPriceChannelMarkup')),
  },
  {
    title: 'stepper',
    path: '/check-in-airport',
    requireAuth: true,
    container: lazy(() => import('../containers/StepperAirPort')),
  },
  {
    title: 'Dispatch List',
    path: '/dispatch',
    requireAuth: true,
    container: lazy(() => import('../containers/DispatchList')),
  },
  {
    title: 'Reservation Dashboard',
    path: '/reservation-dashboard',
    requireAuth: true,
    container: lazy(() => import('../containers/ReservationDashboard')),
  },
  {
    title: 'Driver Management',
    path: '/driver',
    requireAuth: true,
    container: lazy(() => import('../containers/Driver')),
  },
  {
    title: 'Shift Management',
    path: '/driver/shift',
    requireAuth: true,
    container: lazy(() => import('../containers/DriverShift')),
  },
  {
    title: 'View Bookings',
    path: '/driver/bookings',
    requireAuth: true,
    container: lazy(() => import('../containers/ViewBookings')),
  },
  {
    title: 'Driver Manage',
    path: '/driver/dashboard',
    requireAuth: true,
    container: lazy(() => import('../containers/DriverDashboard')),
  },
  {
    title: 'Booking Invoice',
    path: '/booking-invoice/:bookingId',
    requireAuth: true,
    container: lazy(() => import('../containers/BookingList/BookingInvoice')),
  },
  {
    title: 'Van with driver / driver',
    path: '/van-with-driver/driver-manage',
    requireAuth: true,
    container: lazy(() => import('../containers/VanWithDriver/DriverDashboard')),
  },
  {
    title: 'Van with driver / driver create',
    path: '/van-with-driver/driver-manage/create',
    requireAuth: true,
    container: lazy(
      () => import('../containers/VanWithDriver/DriverDashboard/DriverDashBoardCreate'),
    ),
  },
  {
    title: 'Van with driver / driver edit',
    path: '/van-with-driver/driver-manage-edit/:id',
    requireAuth: true,
    container: lazy(
      () => import('../containers/VanWithDriver/DriverDashboard/DriverDashBoardEdit'),
    ),
  },
  {
    title: 'Van with driver / addon',
    path: '/van-with-driver/addon-manage',
    requireAuth: true,
    container: lazy(() => import('../containers/VanWithDriver/AddonDashboard')),
  },
  {
    title: 'Van with driver / addon create',
    path: '/van-with-driver/addon-manage/create',
    requireAuth: true,
    container: lazy(
      () => import('../containers/VanWithDriver/AddonDashboard/AddonDashBoardCreate'),
    ),
  },
  {
    title: 'Van with driver / addon edit',
    path: '/van-with-driver/addon-manage-edit/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/VanWithDriver/AddonDashboard/AddonDashBoardEdit')),
  },
  {
    title: 'Van with driver / vehicle',
    path: '/van-with-driver/vehicle-manage',
    requireAuth: true,
    container: lazy(() => import('../containers/VanWithDriver/VehicleDashBoard')),
  },
  {
    title: 'Van with driver / vehicle create',
    path: '/van-with-driver/vehicle-manage/create',
    requireAuth: true,
    container: lazy(
      () => import('../containers/VanWithDriver/VehicleDashBoard/VehicleDashBoardCreate'),
    ),
  },
  {
    title: 'Van with driver / vehicle edit',
    path: '/van-with-driver/vehicle-manage-edit/:id',
    requireAuth: true,
    container: lazy(
      () => import('../containers/VanWithDriver/VehicleDashBoard/VehicleDashBoardEdit'),
    ),
  },
  {
    title: 'Van with driver / destination',
    path: '/van-with-driver/destination-manage',
    requireAuth: true,
    container: lazy(() => import('../containers/VanWithDriver/DestinationDashboard')),
  },
  {
    title: 'Van with driver / destination create',
    path: '/van-with-driver/destination-manage/create',
    requireAuth: true,
    container: lazy(
      () => import('../containers/VanWithDriver/DestinationDashboard/DestinationDashBoardCreate'),
    ),
  },
  {
    title: 'Van with driver / destination edit',
    path: '/van-with-driver/destination-manage-edit/:id',
    requireAuth: true,
    container: lazy(
      () => import('../containers/VanWithDriver/DestinationDashboard/DestinationDashBoardEdit'),
    ),
  },
  {
    title: 'Van with driver / booking',
    path: '/van-with-driver/booking-manage',
    requireAuth: true,
    container: lazy(() => import('../containers/VanWithDriver/BookingDashboard')),
  },
  {
    title: 'Van with driver / booking',
    path: '/van-with-driver/booking-manage/create',
    requireAuth: true,
    container: lazy(
      () => import('../containers/VanWithDriver/BookingDashboard/BookingDashBoardCreate'),
    ),
  },
  {
    title: 'Van with driver / booking edit',
    path: '/van-with-driver/booking-manage-edit/:id',
    requireAuth: true,
    container: lazy(
      () => import('../containers/VanWithDriver/BookingDashboard/BookingDashBoardEdit'),
    ),
  },
  {
    title: 'Van with driver / class',
    path: '/van-with-driver/class-manage',
    requireAuth: true,
    container: lazy(() => import('../containers/VanWithDriver/VehicleClass/List')),
  },
  {
    title: 'Van with driver / class create',
    path: '/van-with-driver/class-manage/create',
    requireAuth: true,
    container: lazy(() => import('../containers/VanWithDriver/VehicleClass/Create')),
  },
  {
    title: 'Van with driver / class edit',
    path: '/van-with-driver/class-manage/edit/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/VanWithDriver/VehicleClass/Edit')),
  },
  {
    title: 'Hospital Tranfer',
    path: '/Hostpitaltranfer',
    requireAuth: true,
    container: lazy(() => import('../containers/Hostpitaltranfer')),
  },

  // Charter Service Routes
  {
    title: 'Charter Service - Booking List',
    path: '/charter-service/booking-manage',
    requireAuth: true,
    container: lazy(() => import('../containers/CharterService')),
  },
  {
    title: 'Charter Service - Booking Detail',
    path: '/charter-service/booking-manage/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/CharterService/BookingDetail')),
  },
  {
    title: 'Car with Driver - Car Type Photos',
    path: '/carrentalhaupai',
    requireAuth: true,
    container: lazy(() => import('../containers/carrentalhaupai/carrentalhaupai')),
  },

  {
    title: 'Revenue Summary',
    path: '/summary-revenue',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/SummaryRevenue/index')),
  },
  {
    title: 'Reservation Revenue Summary',
    path: '/summary-revenue/reservation',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/ReservationRevenue/index')),
  },
  {
    title: 'Reservation Revenue Summary',
    path: '/summary-revenue/reservation/missing',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/MissingReservationRevenue/index')),
  },
  {
    title: 'Reservation Revenue Summary',
    path: '/summary-revenue/reservation/reservation-logs',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/RevenueLogsReservation/index')),
  },
  {
    title: 'Issue Dashboard Parking',
    path: '/summary-revenue/issue-dashboard-parking',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/issuedashboardparking/index')),
  },
  {
    title: 'Partner Summary Revenue',
    path: '/summary-revenue/partner',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/PartnerRevenue/index')),
  },
  {
    title: 'Partner Revenue Dashboard',
    path: '/summary-revenue/partner-dashboard',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/AdminDashboardPartner')),
  },
  {
    title: 'Partner Revenue Dashboard Detail',
    path: '/summary-revenue/partner-dashboard/:userid',
    requireAuth: true,
    container: lazy(
      () => import('../containers/SummaryRevenue/AdminDashboardPartner/PartnerDetail'),
    ),
  },
  {
    title: 'Transfer Request Partner',
    path: '/summary-revenue/transfer-request',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/TransferRequest/index')),
  },
  {
    title: 'Withholding Tax Email Sender',
    path: '/summary-revenue/withholding-tax-email',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/WithholdingTaxEmail/index')),
  },
  {
    title: 'WHT Certificate Manager',
    path: '/summary-revenue/wht-certificate-manager',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/WhtCertificateManager/index')),
  },
  {
    title: 'Partner Invoice Payment',
    path: '/summary-revenue/partner-invoice-payment',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/PaymentInvoiceRequest/index')),
  },
  {
    title: 'Invoice',
    path: '/summary-revenue/invoice',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/invoice/index')),
  },
  {
    title: 'Parking Station Revenue',
    path: '/summary-revenue/parking-station',
    requireAuth: true,
    container: lazy(() => import('../containers/SummaryRevenue/ParkingRevenueStation/index')),
  },
  {
    title: 'Station Analysis',
    path: '/summary-revenue/parking-station/analysis',
    requireAuth: true,
    container: lazy(
      () => import('../containers/SummaryRevenue/ParkingRevenueStation/StationAnalysisPage/index'),
    ),
  },
  {
    title: 'Add Issue',
    path: '/summary-revenue/parking-station/add-issue',
    requireAuth: true,
    container: lazy(
      () => import('../containers/SummaryRevenue/issuedashboardparking/AddIssuePage'),
    ),
  },
  {
    title: 'Station Email Send Log',
    path: '/summary-revenue/parking-station/email-log',
    requireAuth: true,
    container: lazy(
      () => import('../containers/SummaryRevenue/ParkingRevenueStation/EmailLogPage/index'),
    ),
  },
  {
    title: 'Revenue Management',
    path: '/auto-revenue',
    requireAuth: true,
    container: lazy(() => import('../containers/AutoRevenue/partner-income-lists')),
  },
  {
    title: 'Partner Revenue',
    path: '/auto-revenue/partner',
    requireAuth: true,
    container: lazy(() => import('../containers/AutoRevenue/partner-revenue')),
  },
  {
    title: 'Airport Request List',
    path: '/airport/package/request',
    requireAuth: true,
    container: lazy(() => import('../containers/AirportPackage/TransactionList')),
  },
  {
    title: 'Airport Package Purchase',
    path: '/airport/package/purchase',
    requireAuth: true,
    container: lazy(() => import('../containers/AirportPackage/CreateTransaction')),
  },
  {
    title: 'Airport Package Accounting',
    path: '/airport/package/accounting',
    requireAuth: true,
    container: lazy(() => import('../containers/AirportPackage/TransactionAccounting')),
  },
  {
    title: 'User - Building Management',
    path: '/building-management/user',
    requireAuth: true,
    container: lazy(() => import('../containers/BuildingManagement/User')),
  },
  {
    title: 'Company - Building Management',
    path: '/building-management/company',
    requireAuth: true,
    container: lazy(() => import('../containers/BuildingManagement/Company')),
  },
  {
    title: 'Building - Building Management',
    path: '/building-management/building',
    requireAuth: true,
    container: lazy(() => import('../containers/BuildingManagement/Building')),
  },
  {
    title: 'Airport Vehicle Model',
    path: '/airport/vehicle',
    requireAuth: true,
    container: lazy(() => import('../containers/AirportVehicle')),
  },
  {
    title: 'Airport Parking',
    path: '/airport/parking',
    requireAuth: true,
    container: lazy(() => import('../containers/airportparking')),
  },
  {
    title: 'Airport Transfer Package',
    path: '/airport/package',
    requireAuth: true,
    container: lazy(() => import('../containers/AirportPackage/PackageList')),
  },
  {
    title: 'Fast Track List',
    path: '/airport/fast-track',
    requireAuth: true,
    container: lazy(() => import('../containers/FastTrack/List')),
  },
  {
    title: 'Fast Track Item List',
    path: '/airport/fast-track/:code/items',
    requireAuth: true,
    container: lazy(() => import('../containers/FastTrack/Items')),
  },
  {
    title: 'Ordering menu group',
    path: '/menu/order',
    requireAuth: true,
    container: lazy(() => import('../containers/MenuList/Order')),
  },
  {
    title: 'Addon Master',
    path: '/addon/master',
    requireAuth: true,
    container: lazy(() => import('../containers/AddonModule/index')),
  },
  {
    title: 'Addon Inventory',
    path: '/addon/inventory',
    requireAuth: true,
    container: lazy(() => import('../containers/AddonModule/Inventory/index')),
  },
  {
    title: 'Addon Order',
    path: '/addon/orders',
    requireAuth: true,
    container: lazy(() => import('../containers/AddonModule/OrderItems/index')),
  },
  {
    title: 'Task Type',
    path: '/task/types',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/TaskType/index')),
  },
  {
    title: 'Task tag',
    path: '/task/tags',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/Tag/index')),
  },

  {
    title: 'Task Field Template',
    path: '/task/field/template',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/Template/index')),
  },
  {
    title: 'Task Form List',
    path: '/task/form',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/TaskFormFields/Form/List/index')),
  },
  {
    title: 'Create Form Field',
    path: '/task/form/:slug/field/create',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/TaskFormFields/Fields/Create')),
  },
  {
    title: 'Edit Form Field',
    path: '/task/form/:slug/field/:field',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/TaskFormFields/Fields/Edit')),
  },
  {
    title: 'Create Form',
    path: '/task/form/create',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/TaskFormFields/Form/Create/index')),
  },
  {
    title: 'Update Form and fields',
    path: '/task/form/:slug',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/TaskFormFields/Form/Edit/index')),
  },
  {
    title: 'Task Management',
    path: '/task/list',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/Dashboard')),
  },
  {
    title: 'Task Management',
    path: '/task/create',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/TaskModule/task_handler')),
  },
  {
    title: 'Task Management',
    path: '/task/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/TaskManagement/TaskModule/task_handler')),
  },
  {
    title: 'Accounting Links',
    path: '/task/:id/accounting-links',
    requireAuth: true,
    container: lazy(() => import('../containers/AccountTaskLink')),
  },
  {
    title: 'Accounting Links',
    path: '/accounting-task-links',
    requireAuth: true,
    container: lazy(() => import('../containers/AccountTaskLinkAll')),
  },
  {
    title: 'Package Master Management',
    path: '/ctrip/package/master/list',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/PackageMaster/List/index')),
  },
  {
    title: 'Ctrip Booking Report Download',
    path: '/ctrip/booking/report',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/BookingList/Report/index')),
  },
  {
    title: 'C Trip Create Package Master',
    path: '/ctrip/package/master/create',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/PackageMaster/Create/index')),
  },
  {
    title: 'C Trip Create Edit Master',
    path: '/ctrip/package/master/edit/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/PackageMaster/Edit/index')),
  },
  {
    title: 'C Trip Booking Management',
    path: '/ctrip/booking/list',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/BookingList/index')),
  },
  {
    title: 'C Trip Package Management',
    path: '/ctrip/package/list',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/Package/index')),
  },
  {
    title: 'C Trip Branch Management',
    path: '/ctrip/branch/list',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/Branch/index')),
  },
  {
    title: 'C Trip Branch Addon Management',
    path: '/ctrip/branch/addon/list',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/BranchAddon/index')),
  },
  {
    title: 'C Trip Branch Model Management',
    path: '/ctrip/branch/model/list',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/BranchModel/index')),
  },
  {
    title: 'C Trip Branch Model Management',
    path: '/ctrip/branch/model/:id/pricing',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/BranchModel/Pricing/index')),
  },
  {
    title: 'C trip Booking Spec Equipment',
    path: '/ctrip/booking/special-equipment/list',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/BookingSpecEquip/index')),
  },
  {
    title: 'C trip Deduction',
    path: '/ctrip/booking/deduction',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/Deduction/index')),
  },
  {
    title: 'C Trip Deduction Trip Order',
    path: '/ctrip/booking/deduction/:id/trip-order',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/Deduction/requestDeduction/index')),
  },
  {
    title: 'C Trip Block Time Management',
    path: '/ctrip/block-time',
    requireAuth: true,
    container: lazy(() => import('../containers/OpenApiModule/BlockTime/index')),
  },
  {
    title: 'Home Page Banner',
    path: '/homepage-banner',
    requireAuth: true,
    container: lazy(() => import('../containers/HomePageBanner')),
  },
  {
    title: 'Request Campaign',
    path: '/request-campaign',
    requireAuth: true,
    container: lazy(() => import('../containers/RequestCampaign')),
  },
  {
    title: 'Activity Booking',
    path: '/activity/booking-listing',
    requireAuth: true,
    container: lazy(() => import('../containers/ActivityBooking')),
  },
  {
    title: 'Car Request',
    path: '/car-request',
    requireAuth: true,
    container: lazy(() => import('../containers/CarRequest')),
  },
  {
    title: 'Car Request Detail',
    path: '/car-request/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/CarRequestDetail')),
  },
  {
    title: 'OTA Dashboard',
    path: '/ota-dashboard',
    requireAuth: true,
    container: lazy(() => import('../containers/OTADashboard')),
  },
  {
    title: 'Submission Tracking',
    path: '/submission-tracking',
    requireAuth: true,
    container: lazy(() => import('../containers/SubmissionTracking')),
  },
  {
    title: 'Deposit Tracking',
    path: '/deposit-tracking',
    requireAuth: true,
    container: lazy(() => import('../containers/DepositTracking')),
  },
  {
    title: 'Social Media Groups',
    path: '/social-media-groups',
    requireAuth: true,
    container: lazy(() => import('../containers/SocialMediaGroups')),
  },
  {
    title: 'Social Media Workflow',
    path: '/social-media-groups/facebook/workflow',
    requireAuth: true,
    container: lazy(() => import('../containers/SocialMediaGroups/Workflow')),
  },
  {
    title: 'AI Comment Workflow',
    path: '/social-media-groups/facebook/ai-workflow',
    requireAuth: true,
    container: lazy(() => import('../containers/SocialMediaGroups/AiWorkflow')),
  },
  {
    title: 'LINE Broadcast',
    path: '/social-media-groups/line/broadcast',
    requireAuth: true,
    container: lazy(() => import('../containers/SocialMediaGroups/LineBroadcast')),
  },
  {
    title: 'LINE Broadcast Templates',
    path: '/social-media-groups/line/templates',
    requireAuth: true,
    container: lazy(() => import('../containers/LineBroadcastTemplates')),
  },
  {
    title: 'LINE Auto-Broadcast Log',
    path: '/social-media-groups/line/auto-broadcast-log',
    requireAuth: true,
    container: lazy(() => import('../containers/LineBroadcastLog')),
  },
  {
    title: 'LINE Schedule Templates',
    path: '/social-media-groups/line/schedule-templates',
    requireAuth: true,
    container: lazy(() => import('../containers/LineScheduleTemplates')),
  },
  {
    title: 'LINE Scheduled Broadcast Log',
    path: '/social-media-groups/line/schedule-log',
    requireAuth: true,
    container: lazy(() => import('../containers/LineScheduleLog')),
  },
  {
    title: 'Ski Storage Booking',
    path: '/ski-storage/bookings',
    requireAuth: true,
    container: lazy(() => import('../containers/SkiStorageBooking')),
  },
  {
    title: 'Ski Storage Booking Detail',
    path: '/ski-storage/bookings/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/SkiStorageBooking/Detail')),
  },
  {
    title: 'Queue Booking',
    path: '/queue/bookings',
    requireAuth: true,
    container: lazy(() => import('../containers/QueueBooking')),
  },
  {
    title: 'Queue Booking Detail',
    path: '/queue/bookings/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/QueueBooking/Detail')),
  },
  {
    title: 'Station Rent Payment',
    path: '/station-rent-payment',
    requireAuth: true,
    container: lazy(() => import('../containers/StationRentPayment')),
  },
  {
    title: 'Station Rent Payment — Email Log',
    path: '/station-rent-payment/email-log',
    requireAuth: true,
    container: lazy(() => import('../containers/StationRentPayment/EmailLog')),
  },
  {
    title: 'Station Rent Payment Detail',
    path: '/station-rent-payment/:id',
    requireAuth: true,
    container: lazy(() => import('../containers/StationRentPayment/Detail')),
  },
  {
    title: 'AI suggestion analytics',
    path: '/line/chat/ai-analytics',
    requireAuth: true,
    container: lazy(() => import('../containers/LineChat/AiAnalytics')),
  },
  {
    title: 'LINE Chat report',
    path: '/line/chat/report',
    requireAuth: true,
    container: lazy(() => import('../containers/LineChat/Performance')),
  },
  {
    title: 'Sales strategy',
    path: '/line/chat/sales-strategy',
    requireAuth: true,
    container: lazy(() => import('../containers/LineChat/SalesStrategy')),
  },
  {
    title: 'LINE Chat',
    path: '/line/chat/:uuid?',
    requireAuth: true,
    container: lazy(() => import('../containers/LineChat')),
  },
  {
    title: 'LINE App Management',
    path: '/line/apps',
    requireAuth: true,
    container: lazy(() => import('../containers/LineAppPermissions')),
  },
  {
    title: 'Station Relation',
    path: '/ev-charger/station-relation',
    requireAuth: true,
    container: lazy(() => import('../containers/StationRelation')),
  },
  {
    title: 'Submission Feedback Loop',
    path: '/analytics/submission-feedback-loop',
    requireAuth: true,
    container: lazy(() => import('../containers/FeedbackLoopSubmission')),
  },
  {
    title: 'Submission Feedback Loop Detail',
    path: '/analytics/submission-feedback-loop/:vehicleId',
    requireAuth: true,
    container: lazy(() => import('../containers/FeedbackLoopSubmission/Detail')),
  },
  {
    title: 'Green Energy',
    path: '/green-energy',
    requireAuth: true,
    container: lazy(() => import('../containers/GreenEnergy')),
  },
  {
    title: 'Revenue Intelligence',
    path: '/analytics/revenue-intelligence',
    requireAuth: true,
    container: RevenueIntelligenceGuarded,
  },
  {
    title: 'MUVMI Management',
    path: '/muvmi-management',
    requireAuth: true,
    container: lazy(() => import('../containers/MuvmiManagement')),
  },
]

// Function to check for duplicated route
// const count = routes.reduce((acc, route) => {
//   if (route.path in acc) {
//     const prevCount = acc[route.path]
//     const currentCount = prevCount + 1
//     return {
//       ...acc,
//       [route.path]: currentCount,
//     }
//   }
//   return {
//     ...acc,
//     [route.path]: 1,
//   }
// }, {} as Record<string, number>)

// Object.entries(count).map(([key, value]) => {
//   if (value > 1) {
//     throw new Error(`Route ${key} is duplicated.`)
//   }
// })

export default routes
